import { api } from "./base.api";

export const systemAPI = {
  getAffiliateCommissions: async () => {
    const response = await api.get<any>("/system/affiliate-commissions");
    return response.data;
  },

  getCurrencyPairs: async () => {
    const response = await api.get<any>("/system/currency-pairs");
    return response.data;
  },

  getDepositBonuses: async () => {
    const response = await api.get<any>("/system/deposit-bonuses");
    return response.data;
  },
};
